import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  fill: "none",
  viewBox: "0 0 19 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M.75 9.083a8.333 8.333 0 0 0 8.333 8.334 2.5 2.5 0 0 0 2.5-2.5V14.5c0-.387 0-.58.022-.743a2.5 2.5 0 0 1 2.152-2.152c.162-.022.356-.022.743-.022h.417a2.5 2.5 0 0 0 2.5-2.5 8.333 8.333 0 0 0-16.667 0"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M4.917 9.917a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667M12.417 6.583a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666M7.417 5.75a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667"
    }, null, -1)
  ]))]))
}
export default { render: render }